const urls = {
  stats: process.env.REACT_APP_STATS_URL || 'https://www.ufastats.com',
};

export default urls;
